import request from "@/utils/request";

export function getPostRequest(srl_madrak) {
  return request({
    url: "postRequest/Get",
    method: "post",
    data: { srl_madrak },
  });
}

export function savePostRequest(data) {
  const {
    srl_madrak,
    srl_city,
    Address,
    Mobile,
    PostalCode,
    TahvilGirandeh,
  } = data;
  return request({
    url: "postRequest/Save",
    method: "post",
    data: { srl_madrak, srl_city, Address, Mobile, PostalCode, TahvilGirandeh },
  });
}

export function startPaymentPostRequest(reqId) {
  return request({
    url: "postRequest/StartPayment",
    method: "post",
    data: { RequestId: `${reqId}` },
  });
}
